import { useEffect, useMemo, useState } from "react";
import { IHeaderTable } from "../../../../types/global";

export const useDepositListPdfHeader = () => {
  const [headers, setHeaders] = useState<IHeaderTable[]>([]);
  const columns = useMemo<IHeaderTable[]>(
    () => [
      {
        thaiLabel: "",
        width: 20,
        align: "left",
      },
      {
        thaiLabel: "รายละเอียดรายการ",
        width: 340,
        align: "left",
      },
      {
        thaiLabel: "จำนวนเงิน",
        width: 75,
        align: "right",
      },
      {
        thaiLabel: "",
        width: 32,
      },
    ],
    []
  );
  useEffect(() => {
    setHeaders(columns);
  }, [columns]);

  return headers;
};
